import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIcon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIcon"><Path d="M21.5 6.5H2.5V20.5H21.5V6.5Z" stroke="currentColor"/><Path d="M7.5 6.5V2.5H16.5V6.5" stroke="currentColor"/><Path d="M9 13.5H15" stroke="currentColor"/><Path d="M12 10.5V16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconIcon;
